import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';
import { commaFormat, commaFormatCurrency } from '@ltvco/refresh-lib/utils';

import { VehicleReportSummaryData } from '../DataTypes/SummaryTypes';

import { BoldSpan } from './components';

interface VehicleReportRendererProps {
  data: VehicleReportSummaryData;
}

export const VehicleReportRenderer = ({ data }: VehicleReportRendererProps) => {
  const vehicleDetails = data.flatVehicleReport.vehicles_info?.vehicle_details;
  const vehicleYear = vehicleDetails?.year || 'N/A';
  const vehicleMake = vehicleDetails?.make || 'N/A';
  const vehicleModel = vehicleDetails?.model || 'N/A';
  const vehicleTrim = vehicleDetails?.trim || '';
  const vehicleFullName =
    `${vehicleYear} ${vehicleMake} ${vehicleModel} ${vehicleTrim}`.trim();

  return (
    <Stack spacing={2}>
      {data.flatVehicleReport.vehicles_info?.searchSource && (
        <Text>
          We found 1 result for the vehicle with{' '}
          <BoldSpan>
            {data.flatVehicleReport.vehicles_info?.searchSource}
          </BoldSpan>
        </Text>
      )}
      <Stack spacing={1.5}>
        <Box>
          <Text sx={{ fontWeight: 700, mb: 1 }}>Vehicle Specs:</Text>
          <Text>
            <BoldSpan>Vehicle:</BoldSpan> {vehicleFullName}
          </Text>
          <Text>
            <BoldSpan>Body Style:</BoldSpan>{' '}
            {vehicleDetails?.body_style || 'N/A'}
          </Text>
          <Text>
            <BoldSpan>Type:</BoldSpan> {vehicleDetails?.type || 'N/A'}
          </Text>
          <Text>
            <BoldSpan>Color:</BoldSpan> {vehicleDetails?.current_color || 'N/A'}
          </Text>
          <Text sx={{ mb: 1 }}>
            <BoldSpan>Made In:</BoldSpan>{' '}
            {data.flatVehicleReport.property_or_address_info?.state || 'N/A'},{' '}
            {data.flatVehicleReport.property_or_address_info?.country || 'N/A'}
          </Text>
        </Box>

        {(data.flatVehicleReport.vehicles_info?.pricing?.invoice_price ||
          data.flatVehicleReport.vehicles_info?.estimated_mileage?.miles) && (
          <Box>
            <Text sx={{ fontWeight: 700, mb: 1 }}>History & Value:</Text>
            <Text sx={{ mb: 1 }}>
              {data.flatVehicleReport.vehicles_info?.pricing?.invoice_price && (
                <>
                  <BoldSpan>💰 Invoice Price:</BoldSpan>{' '}
                  {commaFormatCurrency(
                    Number(
                      data.flatVehicleReport.vehicles_info?.pricing
                        ?.invoice_price
                    )
                  )}
                </>
              )}
            </Text>
            <Text sx={{ mb: 1 }}>
              {data.flatVehicleReport.vehicles_info?.estimated_mileage
                ?.miles && (
                <>
                  <BoldSpan>Estimated Mileage:</BoldSpan>{' '}
                  {commaFormat(
                    Number(
                      data.flatVehicleReport.vehicles_info?.estimated_mileage
                        ?.miles
                    )
                  )}{' '}
                  miles
                </>
              )}
            </Text>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};
